export default {
    url: '',
    template: '<evaluation-public-evaluation form-submission="vm.formSubmission" company="vm.company"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            // TODO :: consider reducing shown fields, all fields should not be seen by another person
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form,evaluationGroup,evaluationGroupI18ns,user,user.company' }).$promise;
        },
        company (CompanyResource, formSubmission) {
            return CompanyResource.publicView({ id: formSubmission.companyId, expand: 'companyI18ns' }).$promise;
        }
    },
    controller ($rootScope, $state, formSubmission, company, WindowConfirmService, CompanyService) {
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }

        this.formSubmission = formSubmission;
        this.company = company;
        $rootScope.formSubmission = formSubmission;

        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/evaluation/evaluation/do/index.js